
import { setLanguage } from '@/plugins/i18n'
import Vue from 'vue'

export default Vue.extend({
  props: {
    absolute: {
      type: Boolean,
    },
    right: { type: Boolean },
  },
  methods: {
    setLanguage,
  },
  computed: {
    isFr() {
      return this.$i18n.locale === 'fr'
    },
  },
})
